import React, { useRef, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./signin.css";
import {
  faAngleLeft,
  faEnvelope,
  faQuestionCircle,
  faStar,
  faUnlockAlt,
  faEye,
  faEyeSlash,
  faMobileAlt,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faGithub,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  FormCheck,
  Container,
  InputGroup,
  Image,
} from "@themesberg/react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/img/state-govt-logo.png";
import { Routes } from "../../routes";
import { useDispatch } from "react-redux";
import CustomButton from "../../components/CustomButton";
import { TOKEN_KEY } from "../../redux/actions/auth";
import { SET_TOKEN, LOGIN, SET_MFA_TOKEN, SET_MFA_USER } from "../../redux/actions/actionTypes";
import { postApi } from "../../redux/api";
import BgImage from "../../assets/img/state-govt-logo.png";
import { LoaderWrapper } from "../HomePage";
import { mainTreasuryModules } from "./user-admin/modules";
import WhatsAppFloatingIcon from "../components/WhatsAppFloatingIcon";
import toast from "react-hot-toast";

const getDefaultRoute = (func) => {
  let allRoutes = [];
  mainTreasuryModules.forEach(m => {
    if(m.subMenu) {
      m.subMenu.forEach(s => allRoutes.push(s))
    } else {
      allRoutes.push(m)
    }
  })

  let foundRoute = allRoutes.find(
    (a) => a.title === func
  );

  return foundRoute;
}

export default () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const history = useNavigate();
  const dispatch = useDispatch();
  const emailInputRef = useRef(null);

  const navigate = useNavigate();
  const isMobile = () => {
    return window.innerWidth > 992;
  };
  const marginTop = isMobile ? -120 : -67;

  const [otpState, setOtpState] = useState({
    showOtp: false,
    otpStep: 'select',
    otpMethod: null,
    otpCode: '',
    sendingOtp: false,
    verifyingOtp: false,
    otpError: '',
    otpTimer: 0,
    pendingUser: null,
    pendingToken: '',
  });
  const otpInputRefs = useRef([]);
  const otpIntervalRef = useRef(null);

  useEffect(() => {
    return () => clearInterval(otpIntervalRef.current);
  }, []);

  const startOtpTimer = () => {
    clearInterval(otpIntervalRef.current);
    setOtpState(prev => ({ ...prev, otpTimer: 60 }));
    otpIntervalRef.current = setInterval(() => {
      setOtpState(prev => {
        if (prev.otpTimer <= 1) {
          clearInterval(otpIntervalRef.current);
          return { ...prev, otpTimer: 0 };
        }
        return { ...prev, otpTimer: prev.otpTimer - 1 };
      });
    }, 1000);
  };

  const handleOtpDigitChange = (index, value) => {
    const digit = value.replace(/\D/g, '');
    if (!digit && value !== '') return;
    const newOtp = otpState.otpCode.split('');
    newOtp[index] = digit;
    setOtpState(prev => ({ ...prev, otpCode: newOtp.join('').slice(0, 6), otpError: '' }));
    if (digit && index < 5) {
      const next = otpInputRefs.current[index + 1];
      if (next) next.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otpState.otpCode[index] && index > 0) {
      const prev = otpInputRefs.current[index - 1];
      if (prev) prev.focus();
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (pasted.length === 6) {
      setOtpState(prev => ({ ...prev, otpCode: pasted, otpError: '' }));
      const last = otpInputRefs.current[5];
      if (last) last.focus();
    }
  };

  const handleOtpVerify = async () => {
    if (otpState.otpCode.length !== 6) return;
    setOtpState(prev => ({ ...prev, verifyingOtp: true, otpError: '' }));
    try {
      const payload = { code: otpState.otpCode, method: otpState.otpMethod };
      if (otpState.otpMethod === 'sms') payload.phone = otpState.pendingUser?.phone;
      if (otpState.otpMethod === 'email') payload.email = otpState.pendingUser?.email;
      const result = await postApi("verify-otp", payload);
      if (result.success) {
        clearInterval(otpIntervalRef.current);
        localStorage.setItem(TOKEN_KEY, otpState.pendingToken);
        dispatch({ type: SET_TOKEN, payload: otpState.pendingToken });
        dispatch({ type: LOGIN, payload: otpState.pendingUser });
        if (otpState.pendingUser && otpState.pendingUser.mda_name && otpState.pendingUser.mda_name !== "") {
          if (!otpState.pendingUser.email || !otpState.pendingUser.phone) {
            toast("Please complete your profile (email & phone) to access all features.");
          }
        }
        toast.success("Verification successful!");
        navigateToDashboard(otpState.pendingUser);
      } else {
        setOtpState(prev => ({ ...prev, otpError: result.msg || 'Invalid verification code. Please try again.', otpCode: '' }));
      }
    } catch {
      setOtpState(prev => ({ ...prev, otpError: 'Verification failed. Please try again.', otpCode: '' }));
    }
    setOtpState(prev => ({ ...prev, verifyingOtp: false }));
  };

  const handleSelectOtpMethod = async (selectedMethod) => {
    setOtpState(prev => ({
      ...prev,
      otpStep: 'verify',
      otpMethod: selectedMethod,
      otpCode: '',
      otpError: '',
      sendingOtp: true,
    }));

    try {
      const payload = { method: selectedMethod };
      if (selectedMethod === 'sms') payload.phone = otpState.pendingUser?.phone;
      if (selectedMethod === 'email') payload.email = otpState.pendingUser?.email;
      const result = await postApi("send-otp", payload);
      if (result.success) {
        setOtpState(prev => ({ ...prev, sendingOtp: false }));
        startOtpTimer();
      } else {
        toast.error(result.msg || "Could not send verification code. Try again.");
        setOtpState(prev => ({ ...prev, sendingOtp: false, otpStep: 'select', otpMethod: null, otpTimer: 0 }));
      }
    } catch {
      toast.error("Could not send verification code. Try again.");
      setOtpState(prev => ({ ...prev, sendingOtp: false, otpStep: 'select', otpMethod: null, otpTimer: 0 }));
    }
  };

  const handleResendOtp = async () => {
    if (otpState.otpTimer > 0) return;
    setOtpState(prev => ({ ...prev, sendingOtp: true, otpError: '' }));
    try {
      const payload = { method: otpState.otpMethod };
      if (otpState.otpMethod === 'sms') payload.phone = otpState.pendingUser?.phone;
      if (otpState.otpMethod === 'email') payload.email = otpState.pendingUser?.email;
      const result = await postApi("send-otp", payload);
      if (result.success) {
        setOtpState(prev => ({ ...prev, sendingOtp: false }));
        startOtpTimer();
        toast.success("Code resent!");
      } else {
        setOtpState(prev => ({ ...prev, sendingOtp: false }));
        toast.error(result.msg || "Failed to resend code. Please try again.");
      }
    } catch {
      setOtpState(prev => ({ ...prev, sendingOtp: false }));
      toast.error("Failed to resend code. Please try again.");
    }
  };

  const handleOtpCancel = () => {
    clearInterval(otpIntervalRef.current);
    setOtpState({
      showOtp: false,
      otpStep: 'select',
      otpMethod: null,
      otpCode: '',
      sendingOtp: false,
      verifyingOtp: false,
      otpError: '',
      otpTimer: 0,
      pendingUser: null,
      pendingToken: '',
    });
  };

  const navigateToDashboard = (user) => {
    const firstItem = user.functionalities.split(",")[0];
    const route = getDefaultRoute(firstItem);
    if (route) {
      history(route.route);
    } else {
      history(Routes.approval.approvalIndex);
    }
  };

  const maskPhone = (phone) => {
    if (!phone || phone.length < 6) return phone;
    return phone.slice(0, 3) + '****' + phone.slice(-3);
  };

  const maskEmail = (email) => {
    if (!email || !email.includes('@')) return email || '';
    const [name, domain] = email.split('@');
    const maskedName = name.length > 2 ? name[0] + '***' + name[name.length - 1] : name;
    return `${maskedName}@${domain}`;
  };

  const handleChange = ({ target: { name, value } }) =>
    setForm((prev) => ({ ...prev, [name]: value }));
  const getDefaultRoute = (func) => {
    let allRoutes = [];
    mainTreasuryModules.forEach(m => {
      if(m.subMenu) {
        m.subMenu.forEach(s => allRoutes.push(s))
      } else {
        allRoutes.push(m)
      }
    })
  
    let foundRoute = allRoutes.find(
      (a) => a.title === func
    );
  
    return foundRoute;
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const resp = await postApi("treasury-app/sign_in", { username: form.username, password: form.password });
      if (resp.success) {
        const user = resp.user;

        // Navigate to MFA verify page where user chooses verification method
        if (resp.mfa_required && resp.mfa_token) {
          dispatch({ type: SET_MFA_TOKEN, payload: resp.mfa_token });
          dispatch({ type: SET_MFA_USER, payload: user });
          navigate("/mfa-verify");
          return;
        }

        // Fallback: legacy path without MFA - show method selection
        if (user?.phone || user?.email) {
          setOtpState({
            showOtp: true,
            otpStep: 'select',
            otpMethod: null,
            otpCode: '',
            sendingOtp: false,
            verifyingOtp: false,
            otpError: '',
            otpTimer: 0,
            pendingUser: user,
            pendingToken: resp.token,
          });
        } else {
          localStorage.setItem(TOKEN_KEY, resp.token);
          dispatch({ type: SET_TOKEN, payload: resp.token });
          dispatch({ type: LOGIN, payload: user });
          if (user && user.mda_name && user.mda_name !== "") {
            if (!user.email || !user.phone) {
              toast("Please complete your profile (email & phone) to access all features.");
            }
          }
          navigateToDashboard(user);
        }
      } else {
        toast.error(resp.msg || "Invalid credentials");
      }
    } catch (err) {
      toast.error("Connection error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoaderWrapper>
      <main>
        <img
          src={logo}
          style={{
            width: "100%",
            height: "100vh",
            opacity: 0.2,
            position: "absolute",
            alignItems: "center",
            zIndex: -1,
          }}
          className="img-fluid"
          alt="logo-img"
        />
        <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
          <Container>
            <Row className="justify-content-center form-bg-image">
              <Col
                xs={12}
                className="d-flex align-items-center justify-content-center"
              >
                <div className="bg-white shadow-soft border rounded border-light p-4 pb-lg-3 p-lg-5 w-100 fmxw-500">
                  <div className="text-center text-md-center mb-4 mt-md-0">
                    <Image src={logo} className="kifmis-logo" />
                    <h5 className="mb-0 mt-2">
                      KATSINA STATE INTEGRATED FINANCIAL MANAGEMENT INFORMATION
                      SYSTEM 
                      <br />
                      (KIFMIS)
                    </h5>
                  </div>
                  {otpState.showOtp ? (
                    <div className="otp-section mt-4">
                      {otpState.otpStep === 'select' ? (
                        <>
                          <div className="text-center mb-3">
                            <h5 className="fw-bold mb-1">Verify Your Identity</h5>
                            <p className="text-muted small mb-0">
                              Choose how you would like to receive your verification code
                            </p>
                          </div>

                          <div className="d-grid gap-3 mb-3">
                            {otpState.pendingUser?.email && (
                              <Card
                                className="border shadow-sm p-3 cursor-pointer text-start bg-light-hover"
                                style={{ cursor: "pointer", transition: "all 0.2s" }}
                                onClick={() => handleSelectOtpMethod("email")}
                              >
                                <div className="d-flex align-items-center justify-content-between">
                                  <div className="d-flex align-items-center">
                                    <div className="p-2 rounded bg-primary text-white me-3 d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                                      <FontAwesomeIcon icon={faEnvelope} />
                                    </div>
                                    <div>
                                      <h6 className="mb-0 fw-bold">Email Verification</h6>
                                      <small className="text-muted">
                                        Send code to {maskEmail(otpState.pendingUser.email)}
                                      </small>
                                    </div>
                                  </div>
                                  <FontAwesomeIcon icon={faChevronRight} className="text-muted small me-1" />
                                </div>
                              </Card>
                            )}

                            {otpState.pendingUser?.phone && (
                              <Card
                                className="border shadow-sm p-3 cursor-pointer text-start bg-light-hover"
                                style={{ cursor: "pointer", transition: "all 0.2s" }}
                                onClick={() => handleSelectOtpMethod("sms")}
                              >
                                <div className="d-flex align-items-center justify-content-between">
                                  <div className="d-flex align-items-center">
                                    <div className="p-2 rounded bg-success text-white me-3 d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px" }}>
                                      <FontAwesomeIcon icon={faMobileAlt} />
                                    </div>
                                    <div>
                                      <h6 className="mb-0 fw-bold">SMS Verification</h6>
                                      <small className="text-muted">
                                        Send code to {maskPhone(otpState.pendingUser.phone)}
                                      </small>
                                    </div>
                                  </div>
                                  <FontAwesomeIcon icon={faChevronRight} className="text-muted small me-1" />
                                </div>
                              </Card>
                            )}
                          </div>

                          <div className="text-center mt-2">
                            <Button
                              variant="link"
                              className="p-0 text-muted small text-decoration-none"
                              onClick={handleOtpCancel}
                            >
                              Cancel & sign out
                            </Button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="text-center mb-3">
                            <h5 className="fw-bold mb-1">Verify Your Identity</h5>
                            <p className="text-muted small mb-0">
                              Enter the 6-digit code sent via {otpState.otpMethod === 'sms' ? `SMS to ${maskPhone(otpState.pendingUser?.phone)}` : `Email to ${maskEmail(otpState.pendingUser?.email)}`}
                              {otpState.otpTimer > 0 ? ` (${otpState.otpTimer}s)` : ''}
                            </p>
                          </div>

                          {otpState.sendingOtp ? (
                            <div className="text-center py-4">
                              <div className="spinner-border text-primary mb-2" role="status" />
                              <p className="text-muted small">Sending verification code...</p>
                            </div>
                          ) : (
                            <>
                              <div className="otp-input-group" onPaste={handleOtpPaste}>
                                {[0,1,2,3,4,5].map(i => (
                                  <input
                                    key={i}
                                    ref={el => otpInputRefs.current[i] = el}
                                    type="text"
                                    maxLength={1}
                                    className={`otp-input ${otpState.otpError ? 'otp-input-error' : ''}`}
                                    value={otpState.otpCode[i] || ''}
                                    onChange={e => handleOtpDigitChange(i, e.target.value)}
                                    onKeyDown={e => handleOtpKeyDown(i, e)}
                                    autoFocus={i === 0}
                                    autoComplete="one-time-code"
                                  />
                                ))}
                              </div>

                              {otpState.otpError && (
                                <p className="text-danger text-center small mt-2 mb-0">{otpState.otpError}</p>
                              )}

                              <Button
                                variant="primary"
                                className="w-100 mt-3"
                                onClick={handleOtpVerify}
                                disabled={otpState.otpCode.length !== 6 || otpState.verifyingOtp}
                              >
                                {otpState.verifyingOtp ? (
                                  <><span className="spinner-border spinner-border-sm me-1" role="status" /> Verifying...</>
                                ) : (
                                  "Verify"
                                )}
                              </Button>

                              <div className="text-center mt-3">
                                {otpState.otpTimer > 0 ? (
                                  <small className="text-muted">Resend code in {otpState.otpTimer}s</small>
                                ) : (
                                  <Button
                                    variant="link"
                                    className="p-0 text-decoration-none"
                                    onClick={handleResendOtp}
                                  >
                                    Resend code
                                  </Button>
                                )}
                              </div>

                              <div className="text-center mt-2">
                                <Button
                                  variant="link"
                                  className="p-0 text-muted small text-decoration-none"
                                  onClick={() => setOtpState(prev => ({ ...prev, otpStep: 'select', otpMethod: null, otpCode: '', otpError: '' }))}
                                >
                                  Change verification method
                                </Button>
                              </div>

                              <div className="text-center mt-2">
                                <Button
                                  variant="link"
                                  className="p-0 text-muted small text-decoration-none"
                                  onClick={handleOtpCancel}
                                >
                                  Cancel & sign out
                                </Button>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  ) : (
                    <Form className="mt-4" onSubmit={handleSubmit}>
                    <Form.Group id="email" className="mb-4">
                      <Form.Label>Your Username</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faEnvelope} />
                        </InputGroup.Text>
                        <Form.Control
                          value={form.username}
                          name="username"
                          onChange={handleChange}
                          autoFocus
                          required
                          type="text"
                          placeholder="abubakar"
                        />
                      </InputGroup>
                    </Form.Group>
                    <Form.Group>
                      <Form.Group id="password" className="mb-4">
                        <Form.Label>Your Password</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <FontAwesomeIcon icon={faUnlockAlt} />
                          </InputGroup.Text>
                          <Form.Control
                            required
                            value={form.password}
                            name="password"
                            onChange={handleChange}
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                          />
                          <InputGroup.Text 
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                          </InputGroup.Text>
                        </InputGroup>
                      </Form.Group>
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <Form.Check type="checkbox">
                          <FormCheck.Input
                            id="defaultCheck5"
                            className="me-2"
                          />
                          <FormCheck.Label
                            htmlFor="defaultCheck5"
                            className="mb-0"
                          >
                            Remember me
                          </FormCheck.Label>
                        </Form.Check>
                        <Link
                          className="small text-end"
                          to="/examples/forgot-password"
                        >
                          Lost password?
                        </Link>
                      </div>
                    </Form.Group>
                    <CustomButton
                      loading={loading}
                      variant="primary"
                      type="submit"
                      className="w-100"
                    >
                      Sign in
                    </CustomButton>
                  </Form>
                  )}
                  <p
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: 12,
                      fontWeight: "bold",
                      marginTop: 10,
                      color: "#087A15",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faQuestionCircle}
                      style={{
                        marginRight: 20,
                      }}
                    />
                    Support Contact: 09113472208
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <div>
          <WhatsAppFloatingIcon phoneNumber="+2349113472208" />
        </div>
      </main>
    </LoaderWrapper>
  );
};
